import { validateCardNumber, validateCVV, validateExpiry } from '@/lib/utils/billing'

/**
 * A card as typed. It never leaves the browser: it is exchanged for a
 * Pagar.me token, and only the token goes to the API.
 */
export interface CardData {
  number: string
  holderName: string
  /** `MM/YY`. */
  expiry: string
  cvv: string
}

export type CardField = keyof CardData

export const emptyCardData = (): CardData => ({ number: '', holderName: '', expiry: '', cvv: '' })

/** i18n keys (namespace `checkout`) of the first problem with each field. */
export const validateCardData = (card: CardData): Partial<Record<CardField, string>> => {
  const errors: Partial<Record<CardField, string>> = {}
  if (!validateCardNumber(card.number)) errors.number = 'purchase.errors.cardNumberInvalid'
  if (card.holderName.trim().length < 3) errors.holderName = 'purchase.errors.cardHolderRequired'
  if (!validateExpiry(card.expiry)) errors.expiry = 'purchase.errors.cardExpiryInvalid'
  if (!validateCVV(card.cvv)) errors.cvv = 'purchase.errors.cardCvvInvalid'
  return errors
}

/** The shape `usePagarme().tokenizeCard` takes. */
export const toTokenizeInput = (card: CardData) => {
  const [month, year] = card.expiry.split('/')
  const yearNumber = parseInt(year, 10)
  return {
    card_number: card.number.replace(/\s/g, ''),
    card_holder_name: card.holderName.trim(),
    card_expiration_month: parseInt(month, 10),
    card_expiration_year: yearNumber < 100 ? 2000 + yearNumber : yearNumber,
    card_cvv: card.cvv
  }
}
